<template>
  <div
    class="pos-sidebar-body tab-content"
    data-scrollbar="true"
    data-height="100%"
  >
    <slot></slot>
  </div>
</template>

<script>
import { TabEventBus } from './EventBus'

export default {
  name: 'TabPanes',
  props: {
    name: { type: String, required: true },
    value: { type: Number, default: 0 }
  },
  mounted () {
    this.$children[this.value].isShow = true

    TabEventBus.$on('tabchange', activeTab => {
      if (this.name !== activeTab.target) return

      this.$children
        .filter(child => child !== this.$children[activeTab.index])
        .forEach(child => (child.isShow = false))
      this.$children[activeTab.index].isShow = true
      this.$emit('change', this.$children.indexOf(activeTab.index))
    })
  },
  watch: {
    value: {
      handler (val) {
        if (this.$children.length > 0) {
          this.$children[val].isShow = true
        }
      },
      immediate: true
    }
  }
}
</script>
